// @ts-ignore — CJS package with no type declarations; resolves within @repo/utils but not from consuming packages
import { OpenLocationCode } from 'open-location-code'

const olc = new OpenLocationCode() as { encode(lat: number, lng: number, len?: number): string }

/**
 * Encode lat/lng to an 11-digit Plus Code (~3.5m precision).
 * Used for storage — full precision.
 */
export const encodePlusCode = (lat: number, lng: number): string => {
  return olc.encode(lat, lng, 11)
}

/**
 * Encode lat/lng to a 10-digit Plus Code (~14m precision).
 * Used for change detection — coarser grid filters GPS drift from parked trucks.
 */
export const encodePlusCode10 = (lat: number, lng: number): string => {
  return olc.encode(lat, lng, 10)
}
